<template>
	<div>
	  <div class="pg-product-list">
	    <header class="jcheader">
	      <div class="jctitle">
	        <h1>{{supplierName}}</h1>
	      </div>
	    </header>
	    <div id="product-list" class="list fixtab">
	      <ul>
	        <li v-for="(item, index) in supplierList" :key="index">
	          <div class="jc_list">
	            <div class="logo">
	            	<img :src="item.logoUrl" alt="" @click="$router.push(`/company?id=${item.companyId}`)"/>
	            </div>
	            <div class="jc_lright">
	              <h3 @click="$router.push(`/company?id=${item.companyId}`)">{{item.companyName}}</h3>
	              <p><a @click="$router.push(`/company?id=${item.companyId}`)">{{item.product_total}}</a>种化学产品</p>
	              <div valign="top" class="jianjie">
	                <div id="smallContent"> 
	                	<span>
	                		简介：{{ item.textLength ? item.description.slice(0, item.textLength) : textCut(item) }}
	                		<a href="javascript:" v-show="item.description && item.description.length > 25" @click="textCut(item)">
	                			{{item.textLength <= 25 ? '展开' : '收起'}}
	                		</a>
	                	</span> 
	                </div>
	                
	              </div>
	            </div>
	          </div>
	        </li>
	       
	        <li data-v-18909a80="" class="nomore" v-show="supplierList.length > 0">没有更多数据了</li>
	      </ul>
	    </div>
	    <div data-v-18909a80="" class="ctrls"><a data-v-18909a80="" href="javascript: void(0)"> <span data-v-18909a80="">
	    	<img src="../../assets/images/home.png" alt="返回首页" @click="$router.push('/')"></span> </a> 
	    	<span><img src="../../assets/images/top.png" alt="回到顶部" id="back" style="display: none" @click="toPeak"></span> 
	    </div>
	  </div>
	</div>
</template>

<script>
import config from '../../common/config'
import {Loading,Message} from 'element-ui';
import axios from 'axios';

	export default {
		name: '',
		data() {
			return {
				supplierList: [],
				supplierName: "",
				supplierId: '',
			}
		},
		created() {
			

			function getUrlSearch(name) {
			  if (!name) return null;
			  var after = window.location.search;
			  after = after.substr(1) || window.location.hash.split('?')[1];
			  if (!after) return null;
			  if (after.indexOf(name) === -1) return null;
			  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
			  var r = decodeURI(after).match(reg);
			  if (!r) return null;
			  return r[2];
			}
			this.supplierName = getUrlSearch('munufacturer_name');
			this.supplierId = getUrlSearch('munufacturer_id');
			// 返回顶部显示
			window.onscroll = function() {
				const dom = document.getElementById('back');
				if(this.scrollY > 100) {
					dom.style.cssText = 'display: show;';
				}else {
					dom.style.cssText = 'display: none;';
				}
			}

			this.getDataList();
    		_hmt.push(['_trackPageview', `/${window.location.hash}`]);
		},
		methods: {
			toPeak() {
				window.scrollTo(0, 0);
			},
			textCut(data) {
				var length = data.description ? data.description.length : '';
				if(data.textLength) {
					// 处理事件
					data.textLength !== 25 ? data.textLength = 25 : data.textLength = data.description.length;
					this.$forceUpdate();
				}else {
					// 处理首次截取
					length > 25 ? data.textLength = 25 :  data.textLength = data.description ? data.description.length : '';
				}
				if(length) {
					return data.description.slice(0, data.textLength)
				}
				
			},
			getDataList() {
				const that = this;

				// config.PHPHOST 
				axios.get(config.PHPHOST+ `/api/web/index.php?r=company/return-product-supply&munufacturer_name=${this.supplierName}&munufacturer_id=${this.supplierId}`).then(res => {
					if(res.data.data.length === 1) {
						that.$router.replace(`/company?id=${res.data.data[0].companyId}`)
					}
					this.supplierList = res.data.data;
				})
			}
		}
	}
</script>


<style lang="less" scoped>
	.pg-product-list {
		.jcheader {
			background: #fff;
		    width: 100%;
		    z-index: 9;
		    display: block;
		    .jctitle {
		    	display: flex;
			    height: 4rem;
			    line-height: 4rem;
			    border-bottom: 1rem solid #f1f1f1;
			    padding: 0 1rem;
			    h1 {
					font-size: 1.6rem;
				    padding-left: 1rem;
				    flex: 1;
			    }
	
		    }
		}
		.ctrls {
			position: fixed;
		    width: 3rem;
		    height: 7rem;
		    bottom: 6rem;
		    right: 1rem;
			img {
				width: 3rem;
			    height: 3rem;
			    margin-bottom: 1rem;
			}
		}
	}
	.jc_list {
		display: flex;
	    position: relative;
	    border-bottom: .1rem solid #e1e1e1;
	    padding-bottom: 1rem;
	    padding-top: 1rem;
	    .logo {
	    	width: 6rem;
		    height: 6rem;
		    margin-left: 1rem;
		    margin-right: 1rem;
		    -webkit-box-flex: 0;
		    -ms-flex: none;
		    flex: none;
		    border-radius: .4rem;
		    border: .1rem solid #e1e1e1;
		    img {
		    	width: 100%;
		    	height: 100%;
		    }
	    }
	    h3 {
	    	margin-top: .5rem;
		    font-size: 1.6rem;
		    line-height: 2rem;
		    overflow: hidden;
		    max-width: 10.6rem;
		    white-space: nowrap;
		    text-overflow: ellipsis;
	    }
	    p {
	    	position: absolute;
		    right: 0.8rem;
		    top: 1.7rem;
		    a {
		    	margin-right: .5rem;
		    	color: #3f89f7;
		    	width: auto !important;
		    	float: left;
		    	border-bottom: 0 !important;
		    }
	    }
	    .jianjie {
	    	font-size: 1rem;
		    color: #666;
		    line-height: 2rem;
		    padding-right: 1rem;
		    a {
		    	color: #3f89f7;
		    }
	    }
	}
</style>


// WEBPACK FOOTER //
// src/components/home/supplier-list.vue